module.exports = __webpack_public_path__ + "static/media/coach_portrait.71f8d645.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/profile/resources/coach_portrait.jpg
// module id = 3454
// module chunks = 0